//Library Imports
import { useState } from "react";
import { Tooltip, Typography } from "antd";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

//Local Imports
import { getPersonImageUrl, removeOnClickBubble } from "utils";
import { DEFAULT_CAMPAIGN_IMAGE } from "../../../constants/types";
import { ReactComponent as Send } from "../../../assets/img/icons/SendingWhite.svg";
import { ReactComponent as Elipsis } from "../../../assets/img/icons/ArticlePopover/Elipsis.svg";
import { ReactComponent as Audience } from "../../../assets/img/icons/Audience.svg";
import { ReactComponent as Click } from "../../../assets/img/icons/Click.svg";
import Setting from "../../../assets/img/icons/Setting.svg";
import ListLight from "../../../assets/img/icons/ListLight.svg";
import ShareMenuPopup from "../../Common/Components/ShareMenuPopup";
import { IListItem } from "../Audience/interface";
import { resetAudienceListDetailsProfiled, resetAudienceListDetailsNonProfiled } from "../Audience/Lists/actions";
import { getScreenResolutionName, getScreenResolution } from "constants/index";
import useQuery from "hooks/useQuery";
import Checkbox from "modules/Common/Components/Checkbox";
interface IListCardProps {
  id?: string;
  handleAddPeople?: any;
  list?: IListItem;
  classname?: string;
  isList?: boolean;
  added?: boolean;
  handleOnClick?: any;
  externalPopover?: any;
  selected?: boolean;
  showCheckbox?: boolean
  onCheckList?: (val: any) => void
  checkboxRightPositionClass?: string
}

const ListCard: React.FC<IListCardProps> = (props) => {
  const { list, classname, isList, added = false, selected = false, showCheckbox, onCheckList, checkboxRightPositionClass } = props;
  let cardClass = added ? "disabled" : classname;
  const history = useHistory();

  const [ellipsisState, setEllipsistate] = useState(false);
  const { Paragraph } = Typography;
  let query = useQuery();

  const getTopContactsThumbnail = (num: number, list: any) => {
    switch (num) {
      case 0:
        return [1, 2, 3, 4].map((item) => DEFAULT_CAMPAIGN_IMAGE);
      case 1:
        return [list[0], ...[1, 2, 3].map((item) => DEFAULT_CAMPAIGN_IMAGE)];
      case 2:
        return [...list.slice(0, 2), ...[1, 2].map((item) => DEFAULT_CAMPAIGN_IMAGE)];
      case 3:
        return [...list.slice(0, 3), ...[1].map((item) => DEFAULT_CAMPAIGN_IMAGE)];

      default:
        return list?.slice(0, 4);
    }
  };

  const getTopContactsPersonIds = (num: number, list: any) => {
    switch (num) {
      case 0:
        return [1, 2, 3, 4].map((item) => null);
      case 1:
        return [list[0], ...[1, 2, 3].map((item) => null)];
      case 2:
        return [...list.slice(0, 2), ...[1, 2].map((item) => null)];
      case 3:
        return [...list.slice(0, 3), ...[1].map((item) => null)];

      default:
        return list?.slice(0, 4);
    }
  };

  const redirect = (listId: number) => {
    if (window.location.pathname === "/audiences/lists") {
      resetAudienceListDetailsProfiled();
      resetAudienceListDetailsNonProfiled();
    }
    if (window.location.pathname.includes("/audiences/lists")) {
      if (window.location.pathname === "/audiences/lists/view") {
        props.handleAddPeople(list?.id, list?.name, "list");
      } else {
        history.push(`/audiences/lists/view?list_id=${listId}`);
      }
    } else if (props.handleAddPeople) {
      props.handleAddPeople(list?.id, list?.name, "list");
    } else if (props.handleOnClick) {
      props.handleOnClick();
    } else {
      history.push(
        `/audiences/lists/view?from=campaign&list_id=${listId}&campaign_id=${query.get("campaign_id")}`
      );
    }
  };
  const topContactsThumbnail = getTopContactsThumbnail(
    list?.topContactsThumbnail?.length || 0,
    list?.topContactsThumbnail
  );

  const topContactsPersonIds = getTopContactsPersonIds(
    list?.topContactsPersonIds?.length || 0,
    list?.topContactsPersonIds
  );

  const getScreenHeight = () => {
    return window.screen.height;
  };

  const getHeightForFirstIndex = () => {
    return getScreenHeight() > 1439 ? 107 : 77;
  };

  const getHeightForOthersIndex = () => {
    return getScreenHeight() > 1439 ? 53 : 37;
  };

  const getWidthForFirstIndex = () => {
    const objInfo = getScreenResolutionName(window.screen.width) as any;
    const node = document.getElementById("audience-list-images") as any;
    return (
      (node?.offsetWidth + getScreenResolution[objInfo]["padding"]) * getScreenResolution[objInfo]["maxWidth"] -
      getScreenResolution[objInfo]["padding"]
    );
  };

  const getWidthForOthersIndex = () => {
    const objInfo = getScreenResolutionName(window.screen.width) as any;
    const node = document.getElementById("audience-list-images") as any;
    return (
      ((node?.offsetWidth + getScreenResolution[objInfo]["padding"]) * getScreenResolution[objInfo]["maxWidth"] -
        getScreenResolution[objInfo]["padding"]) /
      3
    );
  };

  const onClickCheckbox = (event: any) => {
    event.stopPropagation();
    // event.preventDefault();
    if (list && onCheckList) {
      onCheckList(list.id)
    }
    else if (!added) {
      redirect(list && list.id ? list.id : 0)
    }
  }

  return (
    <Wrapper
      id={props?.id}
      className={`${cardClass === undefined ? "" : cardClass}`}
      style={{ cursor: added ? "auto" : "pointer" }}
      onClick={!added ? () => redirect(list && list.id ? list.id : 0) : undefined}
    >
      {/* Toggle Class "multi-items" on Wrapper to show multiple list*/}
      {showCheckbox ? <div className={`${checkboxRightPositionClass ?? checkboxRightPositionClass} check-wrapper`}>
        <Checkbox backgroundColor="#fff" checked={selected} onChange={onClickCheckbox} />
      </div> : null}
      <div className="multi-items-wrapper">
        <div className="card-1">
          <div className="preview">
            {topContactsThumbnail?.slice(0, 3).map((image: any, index: number) => {
              return (
                <div
                  key={index}
                  className={`preview-${index + 1}`}
                  style={{
                    backgroundImage: `url(
                        ${image ? image : DEFAULT_CAMPAIGN_IMAGE}
                      )`,
                  }}
                ></div>
              );
            })}
          </div>
        </div>
        <div className="card-2">
          <div className="preview">
            {topContactsThumbnail?.slice(0, 3).map((image: any, index: number) => {
              return (
                <div
                  key={index}
                  className={`preview-${index + 1}`}
                  style={{
                    backgroundImage: `url(
                        ${image ? image : DEFAULT_CAMPAIGN_IMAGE}
                      )`,
                  }}
                ></div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="preview">
        <div className="pills">
          {list?.settings && (
            <span>
              <img src={Setting} alt="Smart List" />
              Smart List
            </span>
          )}
          {isList && (
            <span className="list-icon">
              <img src={ListLight} alt="ListLight" />
            </span>
          )}
          {/* {props.people && (
            <span>
              <People />
            </span>
          )} */}
        </div>
        {topContactsThumbnail?.slice(0, 3).map((image: any, index: number) => {
          return (
            <div
              key={index}
              className={`preview-${index + 1}`}
              style={{
                backgroundImage: `url(
              ${image
                    ? topContactsPersonIds?.[index]
                      ? getPersonImageUrl(
                        image,
                        index === 0 ? getWidthForFirstIndex() : getWidthForOthersIndex(),
                        index === 0 ? getHeightForFirstIndex() : getHeightForOthersIndex(),
                        topContactsPersonIds?.[index]
                      )
                      : image
                    : DEFAULT_CAMPAIGN_IMAGE
                  }
            )`,
              }}
            ></div>
          );
        })}

        <div
          className={`preview-4`}
          style={{
            backgroundImage: `url(
              ${topContactsThumbnail[3] ? topContactsThumbnail[3] : DEFAULT_CAMPAIGN_IMAGE}
          )`,
          }}
        >
          <span>
            {list?.totalContacts ? (list?.totalContacts - 3 > 0 ? `+${list?.totalContacts - 3}` : "") : ""}
          </span>
        </div>
      </div>
      <div className="details">
        <div className="name">
          <Tooltip placement="top" title={ellipsisState ? list?.name : undefined}>
            <Paragraph
              className={`paragraph-styling ${list?.name?.startsWith("[Cloned]") ? "cloned" : ""}`}
              ellipsis={{ rows: 2, onEllipsis: setEllipsistate }}
            >
              {list?.name?.startsWith("[Cloned]") ? list?.name.substring(8) : list?.name}
            </Paragraph>
          </Tooltip>
        </div>
        {list?.createdBy ? <div className="list-card-detail list-created-by">Created by: <Tooltip placement="top" title={list?.createdBy}>
          <span className="list-card-detail-text">{list?.createdBy}</span>
        </Tooltip></div> : <div style={{ height: "22px" }}></div>}
        {list?.lastUsedBy ? <div className="list-card-detail list-used-by">Last Used by: <Tooltip placement="top" title={list?.lastUsedBy}>
          <span className="list-card-detail-text">
            {list?.lastUsedBy}
          </span>
        </Tooltip></div> : <div style={{ height: "25px" }} className="empty-spacer-class"></div>}
        {/* empty div is not good practice */}
        <div className="actions d-flex justify-content-between">
          <ul className="flex-grow-1 d-flex d-flex justify-content-between">
            <li>
              <Tooltip placement="top" title="Total Contacts">
                <a>
                  <Audience />
                  <span data-id="qa-total-listcard">{list?.totalContacts ?? 0}</span>
                </a>
              </Tooltip>
            </li>
            <li>
              <Tooltip placement="top" title="Emails Sent">
                <a>
                  <Send />
                  <span>{list?.totalSent ?? 0}</span>
                </a>
              </Tooltip>
            </li>
            {/* <li>
              <a>
                <Mail />
                <span>{list?.totalDelivered ?? 0}</span>
              </a>
            </li>
            <li>
              <a>
                <Eye />
                <span>{list?.totalOpens ?? 0}</span>
              </a>
            </li> */}
            <li>
              <Tooltip placement="top" title="Total Clicks">
                <a>
                  <Click />
                  <span>{list?.totalClicks ?? 0}</span>
                </a>
              </Tooltip>
            </li>
            <li className="card-popover">
              {props.externalPopover ? (
                props.externalPopover()
              ) : (
                <ShareMenuPopup data={props}>
                  <a onClick={removeOnClickBubble}>
                    <Elipsis />
                  </a>
                </ShareMenuPopup>
              )}
            </li>
          </ul>
        </div>
      </div>
    </Wrapper>
  );
};

export default ListCard;

const Wrapper = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  margin-bottom: 50px;
  height: calc(100% - 50px);
  float: left;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 7px;
  }
  .list-card-detail{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    letter-spacing: -0.25px;
    color: #67696A;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .list-card-detail-text{
    color: #27ce0a;
  }
  .list-created-by{
    margin-bottom: 5px; 
  }
  .list-used-by{
    margin-bottom: 10px; 
  }
  .right-position {
    top: 28px !important;
  }
  .check-wrapper{
      position:absolute;
      top: 8px;
      right: 8px;
      z-index: 3;
  }
  &.disabled {
    pointer-events: none !important;
    background-color: rgba(225, 225, 225, 0.7) !important;
    cursor: no-drop;
    opacity: 0.6;
    .details {
      display: flex;
      flex-direction: column;
      padding-bottom: 2px;
    }
  }
  &.show-selected {
    opacity: 0.6;
  }
  &.multi-items {
    position: relative;
    overflow: visible;
    width: calc(100% - 20px);
    opacity: 0.6;
    .multi-items-wrapper {
      display: block;
      position: absolute;
      z-index: -1;
      width: 100%;
      height: 100%;
      .card-1 {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 7px;
        }
      }
      .card-2 {
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 7px;
        }
      }
    }
    .preview {
      box-shadow: 2px 0px 7px -4px rgba(0, 0, 0, 0.08);
    }
    .details {
      box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
    }
  }
  &.list-card-sm {
    height: 325px;
    width: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 260px;
    }
    .details {
      display: flex;
      flex-direction: column;
    }
    .name {
      margin-bottom: 10px !important;
      .ant-typography {
        margin-bottom: 0;
        word-break: break-word;
      }
    }
    .actions {
      // padding: 0px 10px;
      > {
        ul {
          li {
            margin-right: 20px;
          }
        }
      }
    }
    .card-popover {
      margin-right: 0px !important;
    }
  }
  .multi-items-wrapper {
    display: none;
  }
  .preview {
    position: relative;
    height: 161px;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    z-index: 1;
    background: #fff;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 7px 7px 0 0;
      height: 114px;
    }
    .pills {
      position: absolute;
      top: 10px;
      left: 12px;
      span,
      a {
        padding: 0 3px;
        float: left;
        font-family: "Roboto Slab", serif;
        font-size: 18px;
        color: #fff;
        font-weight: 600;
        text-shadow: 0 2px 4px rgb(0 0 0 / 50%);
        width: auto;
        &.list-icon {
          margin-top: -5px;
          img {
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              max-width: 30px;
            }
          }
        }
      }
    }
    .preview-1 {
      width: 100%;
      height: 107px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-bottom: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 77px;
      }
    }
    .preview-2 {
      width: 33.3333333333%;
      height: 53px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 37px;
      }
    }
    .preview-3 {
      width: 33.3333333333%;
      height: 53px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      border-left: 1px solid #fff;
      border-right: 1px solid #fff;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 37px;
      }
    }
    .preview-4 {
      width: 33.3333333333%;
      height: 53px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 37px;
      }
      span {
        background-color: rgba(98, 98, 98, 0.5);
        width: 100%;
        height: 100%;
        color: #fff;
        font-size: 18px;
        font-family: "Roboto Slab", serif;
        text-align: center;
        display: block;
        padding-top: 12px;
        font-weight: bold;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
          padding-top: 9px;
        }
      }
    }
  }
  .details {
    padding: 14px 19px 10px 19px;
    background-color: #ffffff;
    float: left;
    width: 100%;
    border-radius: 0 0 10px 10px;
    overflow: hidden;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 0 0 7px 7px;
    }
    .name {
      color: #424b50;
      font-size: 22px;
      line-height: 24px;
      font-weight: 600;
      font-family: "Roboto Slab", serif;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      min-height: 48px;
      margin-bottom: 15px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 16px;
        line-height: 17px;
        min-height: 36px;
      }
      .ant-typography {
        margin-bottom: 0px;
      }
      .paragraph-styling {
        &.cloned {
          &:before {
            content: "[Cloned] ";
            color: #1ec252;
            font-size: 22px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 16px;
            }
          }
        }
      }
    }
    .actions {
      width: 100%;
      ul {
        list-style: none;
        margin: 0 0;
        padding: 0;
        li {
          float: left;
          display: inline-block;
          padding: 0px;
          margin: 0;
          a {
            padding: 0 5px;
            text-align: center;
            display: block;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              padding: 0 3px;
            }
            svg {
              width: 18px;
              max-height: 12px;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                width: 9px;
              }
              path {
                fill: #000000;
                opacity: 0.5;
              }
              g {
                opacity: 1;
              }
            }

            span {
              color: #5e7079;
              font-size: 10px;
              font-family: "helveticaneuebold";
              font-weight: 700;
              display: block;
              text-align: center;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                font-size: 8px;
              }
            }
          }
          &.card-popover {
            float: right;
            padding-top: 8px;
            a {
              svg {
                width: 5px;
                max-height: none;
                @media all and (max-width: 1200px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                }
              }
              img {
                @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                  width: 4px;
                }
              }
            }
          }
        }
      }
    }
  }
`;
